(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dalia-packaging-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dalia-packaging-player')) {
    customElements.define('dalia-packaging-player', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-packaging-play]');
        if (!button || button.dataset.bound) return;
        button.dataset.bound = 'true';
        button.addEventListener('click', () => {
          const template = this.querySelector('template');
          if (!template) return;
          this.replaceChildren(template.content.cloneNode(true));
          const video = this.querySelector('video');
          video.muted = false;
          video.play().catch(() => video.focus());
        }, { once: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
